<template>
  <div class="container-fluid " style="height: 100vh; width: 100vw">
    <div class="spinner-container" v-if="loading == 1">
      <div id="loader"></div>
    </div>
    <div class="row">
      <div
        class="col-lg-2 col-md-2"
        style="paddingleft: 0px; paddingright: 0px"
      >
        <Sidebar />
      </div>
      <div class="col-lg-10 col-md-10 col-sm-12 mt-2 dev animate-bottom">
        <div class="row h3">All Devices</div>
        <div class="row count-row">
          <div class="col form-check text-left">
            <input
              v-model="deviceType"
              @click="custClick"
              class="form-check-input"
              type="radio"
              name="deviceCount"
              id="allDevices"
              value="allDev"
            />
            <span class="badge badge-info">All Devices</span>
            <small style="color: black">{{ onlineCount + offlineCount }}</small>
          </div>
          <div class="col form-check text-center">
            <input
              v-model="deviceType"
              @click="custClick"
              class="form-check-input"
              type="radio"
              name="deviceCount"
              id="onDevices"
              value="onDev"
              checked
            />
            <span class="badge badge-success">Online</span>
            <small style="color: black">{{ onlineCount }}</small>
          </div>
          <div class="col form-check text-right">
            <input
              v-model="deviceType"
              @click="custClick"
              class="form-check-input"
              type="radio"
              name="deviceCount"
              id="offDevices"
              value="offDev"
            />
            <span class="badge badge-danger">Offline</span>
            <small style="color: black">{{ offlineCount }}</small>
          </div>
        </div>

        <div class="row srchfilter  brdrad shdw mt-2">
          <div class="col-lg-3 col-md-3 col-2 searchbar">
            <input
              class="mt-1 form-control"
              id="site-search"
              type="search"
              name="q"
              aria-label="Search through site content"
              placeholder="Search devices by name"
              v-model="search"
              @keyup="currentSearch"
            />
          </div>
          <div class="col-lg-3 offset-md-6 text-right">
            <select
              name="cust-select"
              class="form-control m-1 float-right"
              v-model="custKey"
              @change="custClick()"
            >
              <option value="ALL">All customers</option>
              <option
                v-for="customer in customers"
                v-bind:key="customer._id"
                :value="customer._id"
              >
                {{ customer.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row  brdrad shdw" style="height: inherit; width: inherit">
          <div
            class="col-sm-12 listofdev border"
            style="height: 75vh; overflow-y: auto"
          >
            <div class="row">
              <table class="table table-list">
                <thead class="ubuntu-medium">
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Device Id</th>
                    <th scope="col" class="dropdown">Device Type
                     <!-- <button
                        class="btn btn-sm dropdown-toggle"
                        type="button"
                        data-toggle="dropdown"
                      ></button>
                      <ul class="dropdown-menu p-2">
                        <li @click="filterByDevTp('all')">all</li>
                        <li @click="filterByDevTp('ii')">ii</li>
                        <li @click="filterByDevTp('oo')">oo</li>
                        <li @click="filterByDevTp('oi')">oi</li>
                        <li @click="filterByDevTp('')">na</li>
                      </ul>   -->
                    </th>
                    <th scope="col" class="dropdown">
                      Gas Sensor
                      <!-- <button
                        class="btn btn-sm dropdown-toggle"
                        type="button"
                        data-toggle="dropdown"
                      ></button>
                      <ul class="dropdown-menu p-2">
                        <li @click="filterByGasSensor('all')">All</li>
                        <li @click="filterByGasSensor('true')">True</li>
                        <li @click="filterByGasSensor('false')">False</li>
                      </ul> -->
                    </th>
                    <th scope="col">Last Online</th>
                    <th scope="col"  v-if="roleId == 3">
                      <i class="fas fa-edit"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="devices in filteredAndSorted"
                    v-bind:key="devices._id"
                    class="ubuntu-medium"
                  >
                    <td>
                      <p class="name p-0">
                        <a
                          :href="'#/device/' + devices.devId + '/info'"
                          target="_blank"
                        >
                          <span
                            class="cursor-pointer"
                            data-toggle="tooltip"
                            title="Click for details"
                            >{{ devices.name }}</span
                          >
                        </a>
                      </p>
                    </td>
                    <td>
                      <p class="p-0">
                        <a
                          :href="'#/device/' + devices.devId + '/info'"
                          target="_blank"
                        >
                          <span
                            class="devId cursor-pointer"
                            data-toggle="tooltip"
                            title="Click for details"
                            >{{ devices.devId }}</span
                          >
                        </a>
                      </p>
                    </td>
                    <td>{{ devices.deviceType }}</td>
                    <td>{{ devices.gasSensor }}</td>
                    <td>{{ devices.lastOnline }}</td>
                    <td v-if="roleId == 3">
                      <i
                        @click="routeToUpdate(devices)"
                        class="fas fa-pen"
                        style="cursor: pointer"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
    >
      <div class="modal-dialog modal-sm">
        <div class="modal-content" style="width: 48px">
          <span class="fa fa-spinner fa-spin fa-3x"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import _ from 'underscore';
import { apiCall } from "@/utils/api";
import Sidebar from "./Sidebar";
// import Notification from './Notification';

export default {
  components: {
    Sidebar,
    // Notification,
  },
  data() {
    return {
      loading: 0,
      customers: [],
      totalDevices: [],
      onlineCount: 0,
      offlineCount: 0,
      devices: [],
      sortKey: "",
      search: "",
      reverse: false,
      custKey: "ALL",
      deviceType: "onDev",
      autoRefresh: 0,
      roleId: parseInt(JSON.parse(localStorage.getItem("user")).roleId)
    };
  },
  mounted() {
    this.custClick();
  },
  computed: {
    // filteredUsers() {
    //   return this.devices.filter((device) => {
    //     if (device.name.toLowerCase().includes(this.search.toLowerCase()) ||
    //      device.devId.toLowerCase().includes(this.search.toLowerCase())) {
    //       return device;
    //     }
    //   });
    // },
    filteredAndSorted() {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
        if(this.devices)
      return this.devices
        .filter((device) => {
           if (device.name) {
          return (device.name.toLowerCase().includes(this.search.toLowerCase())
          || device.devId.toLowerCase().includes(this.search.toLowerCase()))
          &&
             (  this.deviceType === "allDev"
                ? true
                : this.deviceType === "onDev" && device.onlineStatus === true
                ? true
                : this.deviceType === "offDev" && device.onlineStatus === false
                ? true
                : false
                
             )}
           else
           {
          return (device.devId.toLowerCase().includes(this.search.toLowerCase()))
          &&
              (this.deviceType === "allDev"
                ? true
                : this.deviceType === "onDev" && device.onlineStatus === true
                ? true
                : this.deviceType === "offDev" && device.onlineStatus === false
                ? true
                : false
              )
                
           }
          // if (device.name) {
          //   return 
        //       device.name.toLowerCase().includes(this.search.toLowerCase() ||
        //         device.devId.toLowerCase().includes(this.search.toLowerCase())
        //          &&
        //       (this.deviceType === "allDev"
        //         ? true
        //         : this.deviceType === "onDev" && device.onlineStatus === true
        //         ? true
        //         : this.deviceType === "offDev" && device.onlineStatus === false
        //         ? true
        //         : false
        //         )
        //     );
        //   } else {
        //     return (
        //       device.devId.toLowerCase().includes(this.search.toLowerCase()) &&
        //       (this.deviceType === "allDev"
        //         ? true
        //         : this.deviceType === "onDev" && device.onlineStatus === true
        //         ? true
        //         : this.deviceType === "offDev" && device.onlineStatus === false
        //         ? true
        //         : false)
        //     );
        //   }
        // }
        // )
        // .sort(compare);
        // })

    }).sort(compare);
  },
  },
  methods: {
    routeToUpdate(id) {
      // console.log("clicked id", id);
      this.$router.push(`/updateDevice/${id.devId}`);
    },
    getAllDevices() {
      this.getAllCustomers();
      apiCall({ url: "device/all", method: "get" })
        .then((result) => {
          this.onlineCount = result.onlineCount;
          this.offlineCount = result.offlineCount;
          this.devices = result.devices;
          this.loading = 0;
        })
        .catch((err) => {
          // console.log(err);
          this.loading = 0;
        });
    },
    getAllCustomers() {
      apiCall({ url: "company", method: "get" }).then((result) => {
        this.customers = result.data;
        if (this.customers.length) {
          // this.custKey = this.customers[0]._id;
          // this.custClick();
        }
        // console.log('result', this.customers);
      });
    },
    custClick() {
      // console.log("custClick",this.custKey)
      if (this.autoRefresh !== 1) {
        this.loading = 1;
        // console.log('Inside auto refrsh check', this.autoRefresh);
      }
      if (this.custKey === "ALL") {
        this.getAllDevices();
      } else {
        const baseURI = `device/by-customer/${this.custKey}`;
        // console.log('baseURI baseURI', baseURI)
        apiCall({ url: baseURI, method: "get" }).then((result) => {
          this.onlineCount = result.onlineCount;
          this.offlineCount = result.offlineCount;
          this.devices = result.devices;
          this.loading = 0;
        });
      }
    },
    currentSearch() {
      // console.log('filtered', this.devices.filter((elm) => elm.includes(this.search)) )
    },
  },
};
</script>
<style>
.container-fluid {
  margin: 0px;
  padding: 0px;
}
.ubuntu-small {
  font-family: Ubuntu;
  font-weight: 200;
  font-size: 10px;
  color: rgba(59, 59, 59, 0.8);
}
.ubuntu-medium {
  font-family: Ubuntu;
  font-weight: 500;
  font-size: 14px;
  color: rgba(59, 59, 59, 0.8);
}
.dev {
  font-family: Ubuntu;
  font-weight: 200;
  color: rgba(59, 59, 59, 0.8);
  padding-left: 2.5rem !important;
  padding-right: 2.2rem !important;
}
a {
  /* color: rgba(59, 59, 59, 0.8); */
  text-decoration: none;
}
.btn:focus {
  box-shadow: none;
}
.form-control {
  color: rgba(59, 59, 59, 0.8);
  font-family: Ubuntu;
  font-weight: 200;
  font-size: 13px;
  height: 2rem !important;
}
.option:hover {
  color: #2295c8;
  background-color: transparent;
}
.form-control:focus {
  box-shadow: none;
  border: none;
}
.option:focus {
  background-color: transparent;
  border: none;
}
.form-check-input {
  margin-top: 0.7rem;
}
.listofdev {
  box-shadow: 0 0.5rem 0.5rem rgba(0, 0, 0, 0.2);
  border-top: none !important;
  padding-left: 0px;
  padding-right: 0px;
}
.srchfilter {
  border-bottom: none !important;
  /* background-color: #2295c8; */
  background-color: rgba(0, 0, 0, 0.1);
  width: 100%;
  border: 1px solid #dedede;
  padding-top: 5px;
  padding-bottom: 5px;
  border-top-left-radius: 0.63rem;
  border-top-right-radius: 0.63rem;
}
a:link {
  text-decoration: none;
}
a {
  color: rgba(59, 59, 59, 0.8);
}
a:hover {
  color: #2295c8;
}
.bd-example-modal-lg .modal-dialog {
  display: table;
  position: relative;
  margin: 0 auto;
  top: calc(50% - 24px);
}

.bd-example-modal-lg .modal-dialog .modal-content {
  background-color: transparent;
  border: none;
}

.model {
  display: block;
}

.count-row {
  font-size: 20px;
}
#loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.6;
  z-index: 1;
  margin: -15px;
}
.dropdown-menu {
  color: grey;
  cursor: pointer;
}
li:hover {
  color: #17a2b8;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s;
}

@-webkit-keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0px;
    opacity: 1;
  }
}

@keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}
</style>
